// extracted by mini-css-extract-plugin
module.exports = {"scrollStrip":"LabelMenu_scrollStrip__3pwwK","item":"LabelMenu_item__25f4a"};